var EventHubEvent = {
  StartPrompt: 'start prompt',
  ReplaceConfluenceTitle: 'replace title in confluence'
};
export var EventHubPrompt = {
  SuggestTitle: 'suggest title in confluence title toolbar',
  CustomPrompt: 'custom prompt',
  IssueReformatter: 'issue reformatter',
  Summarize: 'summarize',
  ImproveWriting: 'improve writing',
  MakeShorter: 'make shorter',
  FixSpellingGrammar: 'fix spelling and grammar',
  ChangeToneToProfessional: 'change tone to professional',
  ChangeToneToNeutral: 'change tone to neutral',
  ChangeToneToEmpathetic: 'change tone to empathetic',
  ChangeToneToCasual: 'change tone to casual',
  ChangeToneToEducational: 'change tone to educational'
};